/**
 * @fileoverview Main application component.
 * @summary Root component that renders the application with routing.
 *
 * @package KaraoNow
 * @module apps/front/src/App
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/index.js'
import { router } from './routes/index.js'
import AuthInitializer from './components/AuthInitializer.js'
import OfflineBanner from './components/OfflineBanner.js'
import CookieBanner from './components/CookieBanner.js'

/**
 * @summary Main App component.
 * @returns {React.ReactElement} Application root.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
function App() {
  return (
    <Provider store={store}>
      <AuthInitializer />
      <RouterProvider router={router} />
      <OfflineBanner />
      <CookieBanner />
    </Provider>
  )
}

export default App

